var $6c3b12dc88d4aad9$exports = {};
$6c3b12dc88d4aad9$exports = {
    "invalidSelection": (args, formatter)=>`${formatter.plural(args.selectedCount, {
            one: `Datos`,
            other: `Dat\u{173}`
        })} pasirinkimas negalimas.`
};


export {$6c3b12dc88d4aad9$exports as default};
//# sourceMappingURL=lt-LT.mjs.map
